module.exports = __webpack_public_path__ + "static/media/National Association for Campus Activities Logo.c9545342.png";